var swiperSellers = new Swiper(".mySwiper-sellers", {
    slidesPerView: 1.5,
    spaceBetween: 10,
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next-best",
      prevEl: ".swiper-button-prev-best",
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    },
  });